import React, { useMemo } from 'react';
import toNumber from 'lodash/toNumber';

import { formatCurrency } from './helper';
import { MoneyProps } from './props';

export const Money: React.FC<MoneyProps> = (props) => {
  const {
    amount = 0,
    format = '0,0.00',
    currency,
    className,
    enableSymbol = false,
    prefix,
    postfix,
    onlyText = false,
    ...restProps
  } = props;

  // ======================= HOOKS
  const actual = useMemo(() => {
    if (typeof amount === 'number') return amount;
    if (typeof amount === 'string') return toNumber(amount);
    return 0;
  }, [amount]);

  // ======================= VARIABLES
  const output = (
    <>
      {prefix}
      {formatCurrency(actual, {
        currency: currency,
        format,
        showSymbol: enableSymbol,
      })}
      {postfix}
    </>
  );

  // ======================= VIEWS
  if (onlyText) return output;
  return (
    <span className={className} {...restProps}>
      {output}
    </span>
  );
};

// ======================= EXPORT
export * from './props';
export default Money;
